import React from 'react';
import { UserAvatarAndName } from "../molecules/UserAvatarAndName";
import { Permission } from '@shared/models/user.models';
import { BodyRegular, BodySmall } from "../atoms/fonts/Body";
import Colours from "../atoms/Colours";
import { OutlineButton } from "../atoms/buttons/OutlineButton";
import { Column } from "../atoms/StructuralLayout";
import { UserRolePill } from "@features/settings/pages/manage-users-page-v2/components/UserRolePill";
import styled from "styled-components";
import { smallTablet } from "../atoms/MediaQueries";

export function UserContentCard(props: Props) {
  return (
    <ContentCard>
      <UserAvatarAndName colour={'darkBlue'}
                         firstName={props?.firstName ?? 'N'}
                         lastName={props?.lastName ?? 'A'}
                         hideName={true} />
      <Row>
        <Column>
          {props.firstName && props.lastName && <BodyRegular weight={600}>{`${props.firstName} ${props.lastName}`}</BodyRegular>}
          {props?.jobTitle && <BodySmall>{props.jobTitle}</BodySmall>}
          {props?.email && <BodySmall colour={Colours.darkGrey}>{props.email}</BodySmall>}
          {!props.hideButton && props.userId && <OutlineButton link={`/manage/user/whereabouts-summary?userId=${props.userId}`}
                                                               text={'button.view-whereabouts-report'}
                                                               style={{marginTop: 12, minWidth: 250}} />}
        </Column>
        <Column className={'userPillWrapper'}>
          {props.role && <UserRolePill role={props.role} />}
        </Column>
      </Row>
    </ContentCard>
  )
}

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  .userPillWrapper {
    margin-top: 16px;
  }
  @media (${smallTablet}) {
    flex-direction: row;
    .userPillWrapper {
      margin-top: 0;
    }
  }
`

const ContentCard = styled.div`
  width: 100%;
  padding: 16px 24px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.10);
  background: #FFF;
  box-shadow: 0 12px 17px 2px rgba(145, 145, 145, 0.15);
  margin-bottom: 32px;
  @media (${smallTablet}) {
    padding: 24px 48px 32px 48px;
  }
`

interface Props {
  firstName?: string;
  lastName?: string;
  role?: Permission;
  email?: string;
  userId?: string;
  jobTitle?: string;
  hideButton?: boolean;
}
